/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from 'react';

const RECHARTS_Y_AXIS_SELECTOR = `.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis`;
const RECHARTS_DEFAULT_Y_AXIS_WIDTH = 60;

type ReturnValues = {
  yAxisWidth: number;
  setChartRef: (chartRef: any) => void;
};

export const useDynamicYAxisWidth = (): ReturnValues => {
  const [yAxisWidth, setYAxisWidth] = useState(RECHARTS_DEFAULT_Y_AXIS_WIDTH);

  const setChartRef = useCallback(
    (chartRef: any) => {
      if (chartRef != null && chartRef.container != null) {
        const yAxisElement = chartRef.container.querySelector(RECHARTS_Y_AXIS_SELECTOR);
        const yAxisBoundingRect = yAxisElement?.getBoundingClientRect();
        const yAxisElementWidth =
          yAxisBoundingRect != null && yAxisBoundingRect.width != null
            ? yAxisBoundingRect.width
            : RECHARTS_DEFAULT_Y_AXIS_WIDTH;
        setYAxisWidth(yAxisElementWidth);
      }
      return chartRef;
    },
    [setYAxisWidth],
  );

  return {
    yAxisWidth,
    setChartRef,
  };
};
